import { fetcher } from "@/utils/fetchers/fetcher";
import { useMutation } from "@tanstack/react-query";

type AppUrlResponse = {
  app_url: string;
};

const getAppUrl = async (app: string) => {
  const response = await fetcher.get<AppUrlResponse>(`/apps/app_url/${app}`, {
    withCredentials: true,
  });

  return response.data;
};

export function useGetAppUrl() {
  return useMutation({
    mutationFn: getAppUrl,
  });
}

